import { MemoryRouter, Route } from 'react-router-dom'
import { EmploymentHistory } from 'shared/components/Onboarding/EmploymentHistory/EmploymentHistory'
import { EMPLOYMENT_ROUTES } from 'shared/components/Onboarding/EmploymentHistory/EmploymentHistory.constants'
import { EmploymentHistoryAddFmcsrValidation } from 'shared/components/Onboarding/EmploymentHistory/EmploymentHistoryFmcsr/EmploymentHistoryAddFmcsrValidation'
import { EmploymentHistoryEditFmcsrValidation } from 'shared/components/Onboarding/EmploymentHistory/EmploymentHistoryFmcsr/EmploymentHistoryEditFmcsrValidation'
import { EmploymentHistoryAddPosition } from 'shared/components/Onboarding/EmploymentHistory/EmploymentHistoryPosition/EmploymentHistoryAddPosition'
import { EmploymentHistoryEditPosition } from 'shared/components/Onboarding/EmploymentHistory/EmploymentHistoryPosition/EmploymentHistoryEditPosition'
import { Handler } from 'shared/helpers/typeHelper'
import { User } from 'shared/models/user'

interface UserEmploymentHistoryOnboardingProps {
  user: User
  handleRedirect: Handler
}

export function UserEmploymentHistoryOnboarding({
  user,
  handleRedirect,
}: UserEmploymentHistoryOnboardingProps) {
  return (
    <MemoryRouter initialEntries={[EMPLOYMENT_ROUTES.ONBOARDING_EMPLOYMENT_HISTORY]} initialIndex={0}>
      <Route exact path={EMPLOYMENT_ROUTES.ONBOARDING_EMPLOYMENT_HISTORY}>
        <EmploymentHistory user={user} handleRedirect={handleRedirect} />
      </Route>
      <Route exact path={EMPLOYMENT_ROUTES.ONBOARDING_EMPLOYMENT_HISTORY_ADD}>
        <EmploymentHistoryAddPosition user={user} />
      </Route>
      <Route exact path={EMPLOYMENT_ROUTES.ONBOARDING_EMPLOYMENT_HISTORY_EDIT}>
        <EmploymentHistoryEditPosition user={user} />
      </Route>
      <Route exact path={EMPLOYMENT_ROUTES.ONBOARDING_EMPLOYMENT_HISTORY_ADD_FMCSR}>
        <EmploymentHistoryAddFmcsrValidation user={user} />
      </Route>
      <Route exact path={EMPLOYMENT_ROUTES.ONBOARDING_EMPLOYMENT_HISTORY_EDIT_FMCSR}>
        <EmploymentHistoryEditFmcsrValidation user={user} />
      </Route>
    </MemoryRouter>
  )
}
